export default function IconBrand() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 5.89961C3.1 6.09961 2.3 6.29961 1.5 6.59961C2.7 9.19961 4.5 11.5996 6.7 13.3996C7.4 12.7996 8 12.1996 8.6 11.5996C7.4 10.5996 6.4 9.49961 5.5 8.29961C5.9 8.29961 6.3 8.19961 6.7 8.19961C8.1 8.19961 9.4 8.39961 10.6 8.89961C11.1 8.19961 11.5 7.39961 11.8 6.59961C10.2 5.99961 8.4 5.59961 6.6 5.59961C5.8 5.69961 4.9 5.79961 4 5.89961Z" fill="white" />
      <path d="M6.7 0.5C5.3 0.5 3.9 0.7 2.5 0.9C1.6 1.1 0.8 1.3 0 1.6C0.1 2.5 0.299998 3.3 0.599998 4.2C1.4 3.9 2.2 3.6 3.1 3.5C4.3 3.2 5.5 3.1 6.7 3.1C8.9 3.1 10.9 3.5 12.8 4.2C13.1 3.4 13.2 2.5 13.4 1.6C11.3 0.9 9 0.5 6.7 0.5Z" fill="white" />
    </svg>
  );
}
